// Lazy load videos using Intersection Observer
document.addEventListener('DOMContentLoaded', function () {
	const videos = document.querySelectorAll('video');

	// If Intersection Observer isn't supported, load all videos immediately
	if (!('IntersectionObserver' in window)) {
		loadAll();
		return;
	}

	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadVideo(entry.target);
					obs.unobserve(entry.target);
				}
			});
		},
		{
			rootMargin: '200px 0px',
		}
	);

	videos.forEach((video) => observer.observe(video));

	// Function to load a video when it comes into view
	function loadVideo(video) {
		const source = video.querySelector('source[data-src]'); // Find the source element with data-src (if exists)
		if (!source || source.src) return;

		source.src = source.dataset.src;
		video.load();

		video.play().catch(() => {});
	}

	function loadAll() {
		videos.forEach(loadVideo);
	}
});
